// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"3258":"6ba76f00451a11be","9374":"b8efbdf81628ab48"}[chunkId] + ".css";
};